import { ClientIllustration } from '@/features/shop-insurance/types';

export type IllustrationDisplayStatus = 'ready' | 'generating' | 'expired' | 'failed';

// Presigned illustration PDF URLs are minted with a 168-hour (7-day) expiry.
const PDF_URL_EXPIRY_MS = 7 * 24 * 60 * 60 * 1000;

export function getIllustrationDisplayStatus(
  illustration: ClientIllustration,
): IllustrationDisplayStatus {
  if (illustration.status === 'error') {
    return 'failed';
  }
  if (illustration.status === 'completed') {
    const generatedAt = new Date(
      illustration.responseDateTime ?? illustration.createdDateTime,
    ).getTime();
    return Date.now() - generatedAt > PDF_URL_EXPIRY_MS ? 'expired' : 'ready';
  }
  return 'generating';
}

export const ILLUSTRATION_DISPLAY_STATUS_LABELS: Record<IllustrationDisplayStatus, string> = {
  ready: 'Ready',
  generating: 'Generating',
  expired: 'Expired',
  failed: 'Failed',
};
